import request from '@/utils/request'
import { envInfo } from '@/constants/envInfo'

/**
 * 设备寻呼
 */
export function callPage(params) {
    return request({
        url: envInfo.bgApp.basePath + '/audio/callPage',
        method: 'get',
        params
    })
}

/**
 * 播放广播
 */
export function playMusic(params) {
    return request({
        url: envInfo.bgApp.attendancePath + '/broadcast/startMusic',
        method: 'get',
        params
    })
}

/**
 * 停止播放
 */
export function stopMusic(params) {
    return request({
        url: envInfo.bgApp.attendancePath + '/broadcast/stopTask',
        method: 'get',
        params
    })
}

/**
 * 设置音量
 */
export function setVol(params) {
    return request({
        url: envInfo.bgApp.attendancePath + '/broadcast/setVolume',
        method: 'get',
        params
    })
}

/**
 * 获取设备信息
 */
export function showDevicesInfo() {
    return request({
        url: envInfo.bgApp.attendancePath + '/broadcast/getDetailList',
        method: 'get',
    })
}


/**
 * 获取音乐列表
 */
export function showMusicInfo(params) {
    return request({
        url: envInfo.bgApp.attendancePath + '/broadcast/getAudioList',
        method: 'get',
        params
    })
}

/**
 * 获取终端设备信息
 */
export function GetEndPointInfo(params) {
    return request({
        url: envInfo.bgApp.basePath + '/client/authClient',
        method: 'get',
        params
    })
}

/**
 * 获取音乐列表
 */
export function GetMusicName(params) {

    return request({
        url: envInfo.bgApp.basePath + '/client/authClient',
        method: 'get',
        params
    })
}

/**
 * 开启广播
 */
export function OnBroadcast(params) {

    return request({
        url: envInfo.bgApp.basePath + '/client/authClient',
        method: 'get',
        params
    })
}

/**
 * 关闭广播
 */
export function OffBroadcast(params) {

    return request({
        url: envInfo.bgApp.basePath + '/client/authClient',
        method: 'get',
        params
    })
}

/**
 * 打开对讲
 */
export function OpenTalkBack(params) {

    return request({
        url: envInfo.bgApp.basePath + '/client/authClient',
        method: 'get',
        params
    })
}

/**
 * 关闭对讲
 */
export function CloseTalkBack(params) {

    return request({
        url: envInfo.bgApp.basePath + '/client/authClient',
        method: 'get',
        params
    })
}

/**
 * 打开MP3
 */
export function PlayMP3(params) {

    return request({
        url: envInfo.bgApp.basePath + '/client/authClient',
        method: 'get',
        params
    })
}

/**
 * 播放控制
 */
export function ControlMP3(params) {

    return request({
        url: envInfo.bgApp.basePath + '/client/authClient',
        method: 'get',
        params
    })
}

/**
 * 设置音量
 */
export function SetVolume(params) {
    return request({
        url: envInfo.bgApp.basePath + '/client/authClient',
        method: 'get',
        params
    })
}
